/* updates price when a variant is selected */
(function () {
  function updateSalePrice (evt) {
    var v   = evt.detail.variant || evt.variant;           // covers most themes
    if (!v) return;

    var box = document.querySelector('.tt-price [data-sale-active]');
    if (!box) return;

    var disc  = parseInt(box.dataset.discount, 10) || 0;
    var sale  = box.dataset.saleActive === 'true';
    var money = Shopify.formatMoney(
                  sale ? v.price - disc : v.price,
                  '{{ shop.money_format }}'
                );

    box.textContent = money;

    var old = box.parentNode.querySelector('.old-price');
    if (old) {
      if (sale) {
        old.textContent = Shopify.formatMoney(v.price, '{{ shop.money_format }}');
        old.style.display = '';
      } else {
        old.style.display = 'none';
      }
    }
  }

  /* most Online-Store 2.0 themes fire ‘variant:change’; legacy code often fires ‘variantChange’ */
  document.addEventListener('variant:change',  updateSalePrice, false);
  document.addEventListener('variantChange',   updateSalePrice, false);
})();
